import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';
import AuthLoader from '../../Loader/Auth';
import CircleLoad from '../../Loader/Circle';
import MailIcon from '../MailIcon';

const ConfirmEmail = ({ loading, user }) => (
  <div className='wf-account__card confirm'>
    {loading ? <CircleLoad /> : <MailIcon />}
    <h2 className='mb-4 font-weight-bold'>Email Confirmation</h2>
    <b>
      {loading
        ? 'Your account is being verified, please wait.'
        : user && user.success === true
        ? 'Your email address has been verified. Login to RegulationCity using your email address.'
        : user && user.reason}
    </b>
    {(!user ||
      (user && user.success === true) ||
      (user &&
        user.success === false &&
        user.reason.includes('Account already confirmed'))) && (
      <Link to={ROUTES.LOGIN} className='w-100'>
        <button className='wf-submit smaller'>
          {loading ? 'Loading' : `Log in`}
          {loading ? <AuthLoader /> : null}
        </button>
      </Link>
    )}
  </div>
);

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  user: state.user.user,
});

export default connect(mapStateToProps)(ConfirmEmail);
